import Vue from 'vue'
import App from './App'
import {store} from '@/_store'
import router from './router/'
import VueMask from 'v-mask'
import { authentication } from './_store/authentication.module'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import { createPinia, PiniaVuePlugin } from 'pinia'
import { connectWebSocket, disconnectWebSocket } from './_services/websocket';

import './globalComponents'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/style/custom.css'
import './assets/style/app.css'

import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(VueMask)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
console.log(authentication.state.status);

if(authentication.state.grants.length){
  connectWebSocket(localStorage.getItem("LoginName"), (msg) => {
    console.log("ЗДЕСЬ");
  })
}
Vue.use(PiniaVuePlugin)
const pinia = createPinia()

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || to.meta.label || to.name;

  const publicPages = ['/', '/login']
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('access_token');
  
  if (authRequired && !loggedIn) {
      return next('/')
  }
  next()
})

window.addEventListener("beforeunload", () => {
  disconnectWebSocket()
})

new Vue({
  el: '#app',
  router,
  store,
  pinia,
  template: '<App/>',
  components: {
    App
  },
  created() {
    AOS.init({ offset: 20 })
  },
})
